import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import { TAB_KEYS } from "@/constants/TabKeys";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import { UserPreferencesNotifications } from "@/modules/user-preferences-notifications";
import { TabView } from "@/ui/tab-view";

import TabGeneral from "./Tabs/TabGeneral";
import TabPassword from "./Tabs/TabPassword";

const Preferences = () => {
  const { t } = useTranslation();

  const tabs = [
    {
      key: TAB_KEYS.PREFERENCES_GENERAL,
      label: t("user:preferences.tabs.general.label"),
      children: <TabGeneral />,
    },
    {
      key: TAB_KEYS.PREFERENCES_PASSWORD,
      label: t("user:preferences.tabs.password.label"),
      children: <TabPassword />,
    },
    {
      key: TAB_KEYS.PREFERENCES_NOTIFICATIONS,
      label: t("user:preferences.tabs.notifications.label"),
      children: <UserPreferencesNotifications />,
    },
  ];

  return (
    <>
      <BaseHeader title={t("navigation:preferences")} />
      <AppLayoutPage>
        <Row justify="left">
          <Col>
            <TabView isNav tabs={tabs} tabPlacement="left" />
          </Col>
        </Row>
      </AppLayoutPage>
    </>
  );
};

export default Preferences;
